import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LogService } from '../../services/log.service';
import { API_BASE_URL } from '../../services/api-base';

@Component({
  selector: 'app-desktop-download',
  templateUrl: './desktop-download.component.html',
  styleUrls: ['./desktop-download.component.scss']
})
export class DesktopDownloadComponent {
  windowsUrl = `${API_BASE_URL}/controlchat/v2/desktop/windows`;
  macUrl = `${API_BASE_URL}/controlchat/v2/desktop/mac`;

  constructor(private logService: LogService, private http: HttpClient) {}

  download(platform: 'windows' | 'mac') {
    const label = platform === 'windows' ? 'Windows' : 'Mac';
    this.logService.register('CONTROLCHAT_DESKTOP_DOWNLOAD', `Download desktop ${label}`).subscribe({
      error: () => {}
    });
    const url = platform === 'windows' ? this.windowsUrl : this.macUrl;
    this.http.get(url, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        const link = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        link.href = objectUrl;
        link.download = platform === 'windows' ? 'ControlChat Setup 0.1.2.exe' : 'ControlChat-mac.dmg';
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(objectUrl);
      },
      error: () => {
        window.location.href = url;
      }
    });
  }
}
